import React, { useEffect } from "react";
import PageChrome, { BuyButton, INK, LIME, BLUE, BG_ALT } from "./components/PageChrome";
import { PRODUCTS } from "./products";

const P = PRODUCTS.cert_fincorp;

const MODULES = [
  ["Fundamentos de Corporate Finance", "Costo de capital, estructura óptima, valuación aplicada."],
  ["Deuda y Capital Markets", "Bonos, emisiones, bursatilizaciones, colocaciones en LATAM y USA."],
  ["M&A y reestructuras", "Del origen del deal al cierre: due diligence, estructura, negociación."],
  ["Reverse mergers e IPOs", "Cómo se lista una empresa en LATAM y en Estados Unidos, paso a paso."],
  ["Crédito estructurado", "Warehouses, borrowing-base, covenants, loan tapes y comités de crédito."],
  ["Proyecto final evaluado", "Estructuras una transacción real y la defiendes ante panel."],
];

const FOR_WHOM = [
  "Profesionales de banca, fondos y fintech que quieren subir de nivel",
  "Quien quiere dedicarse a estructurar deuda y capital markets",
  "Consultores y asesores financieros que buscan una credencial seria",
  "Founders que quieren dominar el lado financiero de su empresa",
];

export default function Certificacion() {
  useEffect(() => { document.title = "Certificación FinCorp · IADA Anáhuac · The Debt Guy"; }, []);
  return (
    <PageChrome active="/certificacion" testid="certificacion-page">
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "80px 40px 40px" }} data-testid="cert-hero">
        <div className="cg-mono cg-eyebrow">— Certificación profesional · avalada por IADA Anáhuac</div>
        <h1 className="cg-h1" style={{ marginTop: 18, maxWidth: 940 }} data-testid="cert-hero-title">
          Certifícate en <span style={{ color: BLUE }}>Corporate Finance & Capital Markets.</span>
        </h1>
        <p style={{ marginTop: 22, fontSize: 19, lineHeight: 1.55, opacity: 0.78, maxWidth: 680 }}>
          El programa de certificación FinCorp para quien quiere dedicarse de verdad a estructurar deuda, M&A y operaciones de mercado — con credencial verificable <strong>avalada por IADA de la Universidad Anáhuac</strong>.
        </p>
        <div style={{ marginTop: 26, display: "inline-flex", alignItems: "center", gap: 14, border: `2px solid ${INK}`, borderRadius: 14, padding: "12px 18px", background: BG_ALT }}>
          <span className="cg-mono" style={{ fontSize: 10, opacity: 0.6 }}>AVAL ACADÉMICO</span>
          <span style={{ fontWeight: 900, letterSpacing: "-0.02em" }}>IADA · Universidad Anáhuac</span>
        </div>
        <div style={{ marginTop: 30, display: "flex", gap: 16, alignItems: "baseline", flexWrap: "wrap" }}>
          <span style={{ fontWeight: 900, fontSize: 38, letterSpacing: "-0.03em" }}>{P.usd} USD</span>
          <span className="cg-mono" style={{ opacity: 0.55, fontSize: 11 }}>≈ {P.mxn} · o en parcialidades</span>
        </div>
        <div style={{ marginTop: 22, display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
          <BuyButton lookupKey={P.key} testid="cert-buy" style={{ padding: "18px 34px", fontSize: 13 }}>Inscribirme →</BuyButton>
          <a href="/#pricing" className="cg-btn cg-btn-outline" data-testid="cert-apply" style={{ padding: "18px 30px", fontSize: 12 }}>Ver todos los programas</a>
        </div>
      </section>

      {/* Modules */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "50px 40px" }} data-testid="cert-modules">
        <div className="cg-mono cg-eyebrow">— Qué vas a dominar</div>
        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 16 }}>
          {MODULES.map(([t, d], i) => (
            <div key={i} className="cg-card" style={{ padding: 26 }}>
              <span className="cg-mono" style={{ color: BLUE, fontSize: 11 }}>MÓDULO {String(i + 1).padStart(2, "0")}</span>
              <div className="cg-h3" style={{ marginTop: 12, fontSize: 20 }}>{t}</div>
              <div style={{ marginTop: 10, opacity: 0.76, lineHeight: 1.5, fontSize: 14.5 }}>{d}</div>
            </div>
          ))}
        </div>
      </section>

      {/* For whom + credential */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "20px 40px 40px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30 }} className="cert-grid">
        <div>
          <div className="cg-mono cg-eyebrow">— Para quién</div>
          <div style={{ marginTop: 18, display: "flex", flexDirection: "column", gap: 12 }}>
            {FOR_WHOM.map((w) => (
              <div key={w} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <span style={{ color: BLUE, fontWeight: 900 }}>→</span>
                <span style={{ fontSize: 15.5, lineHeight: 1.45 }}>{w}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="cg-card" style={{ background: INK, color: "#FFFFFF", boxShadow: `6px 6px 0 ${BLUE}` }}>
          <div className="cg-mono" style={{ color: LIME, fontSize: 10 }}>— TU CREDENCIAL</div>
          <div className="cg-h3" style={{ color: "#FFFFFF", marginTop: 14 }}>Certificado verificable, avalado por IADA Anáhuac.</div>
          <p style={{ marginTop: 14, opacity: 0.82, lineHeight: 1.55, fontSize: 14.5 }}>
            Al terminar y aprobar el proyecto final recibes un certificado con validez académica de la Universidad Anáhuac (IADA), listo para tu LinkedIn y tu CV.
          </p>
        </div>
      </section>
      <style>{`@media (max-width: 820px){ [data-testid="certificacion-page"] .cert-grid { grid-template-columns: 1fr !important; } }`}</style>

      {/* Final CTA */}
      <section style={{ maxWidth: 1100, margin: "0 auto 80px", padding: "20px 40px 0" }}>
        <div style={{ background: LIME, color: INK, border: `2px solid ${INK}`, borderRadius: 20, boxShadow: `6px 6px 0 ${INK}`, padding: "48px 40px", textAlign: "center" }}>
          <h2 className="cg-h2">Conviértelo en tu profesión.</h2>
          <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
            <BuyButton lookupKey={P.key} testid="cert-buy-bottom" className="cg-btn-blue" style={{ padding: "18px 34px", fontSize: 13, color: "#FFFFFF" }}>Inscribirme a la certificación →</BuyButton>
          </div>
        </div>
      </section>
    </PageChrome>
  );
}
